@use '../../styles/tokens' as *;

.wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sectionTitle {
  @include text-heading-3;
  color: $black;
}

// ----- Method select (mirrors Checkout.module.scss's native-select pattern) -----
.formField {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
}
.formLabel {
  @include text-13;
  color: $base-4;
}
.control {
  position: relative;
  width: 100%;
}
.controlBox {
  width: 100%;
  height: 46px;
  padding: 0 15px;
  border: 1px solid white;
  border-radius: 4px;
  background: $white;
  @include text-13;
  color: $black;
  text-align: left;
  outline: none;

  &:focus {
    border-color: $utility-blue;
  }
}
.controlBoxIcon {
  padding-right: 44px;
}
.selectBox {
  cursor: pointer;
}
.nativeSelect {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.selectChevron {
  flex: none;
  width: 18px;
  height: 18px;
  color: $base-4;
}
.selectChevronOverlay {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

// ----- Zuora hosted iframe -----
.zuoraFrame {
  min-height: 180px;
}

// ----- Pay / PayPal buttons -----
.payBtn {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 46px;
  padding: 0 40px 0 30px;
  border: none;
  border-radius: 999px;
  background: $utility-blue;
  margin-top: 45px;
  @include text-13;
  font-weight: 700;
  color: $white;
  cursor: pointer;

  &:disabled {
    background-color: $base-6;
    border-color: $base-6;
    cursor: auto;
  }
}
.payIcon {
  width: 18px;
  height: 18px;
}

.paymentError {
  font-size: 11px;
  color: $brand;
}

// ----- Purchase-limit modal -----
.modalTitle {
  @include text-heading-4;
  color: $black;
  margin: 0 0 16px;
}
.modalBody {
  @include text-13;
  color: $black;
  margin: 0 0 12px;
}
.modalLink {
  @include text-13;
  color: $utility-blue;
  text-decoration: none;
}
.modalActions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.modalCloseBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 24px;
  border: none;
  border-radius: 999px;
  background: $utility-blue;
  @include text-13;
  font-weight: 700;
  color: $white;
  cursor: pointer;
}
